import { render, staticRenderFns } from "./CockpitHeaderDj.vue?vue&type=template&id=c18af006&scoped=true"
import script from "./CockpitHeaderDj.vue?vue&type=script&lang=js"
export * from "./CockpitHeaderDj.vue?vue&type=script&lang=js"
import style0 from "./CockpitHeaderDj.vue?vue&type=style&index=0&id=c18af006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18af006",
  null
  
)

export default component.exports